import { Reveal, Overline } from "@/components/Reveal";

export default function VisionMission() {
  return (
    <section data-testid="vision-mission-section" className="border-t border-line py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Reveal>
          <Overline>Vision</Overline>
          <p
            data-testid="vision-statement"
            className="mt-8 max-w-4xl font-display text-3xl font-medium leading-[1.15] tracking-tight sm:text-4xl lg:text-5xl"
          >
            To lead India's transition towards a{" "}
            <span className="text-volt">zero-emission freight ecosystem</span> —
            through innovation, technology and operational excellence.
          </p>
        </Reveal>

        <div className="mt-24 flex justify-end">
          <Reveal className="max-w-3xl">
            <Overline>Mission</Overline>
            <p
              data-testid="mission-statement"
              className="mt-8 font-display text-2xl font-medium leading-[1.2] tracking-tight text-white/85 sm:text-3xl lg:text-4xl"
            >
              Reliable, efficient, sustainable electric transportation — creating
              value for customers while accelerating{" "}
              <span className="text-cyber">clean mobility</span> across the
              logistics industry.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
